import ConsentManagerChannelsPage from '@/modules/consent-manager/pages/ConsentManagerChannelsPage'
import ConsentManager from '@/modules/consent-manager/pages/ConsentManager'
import ConsentManagerSubscriptionPreferencesPage from '@/modules/consent-manager/pages/ConsentManagerSubscriptionPreferencesPage'
import ConsentAuditLog from '@/modules/consent-manager/pages/ConsentAuditLog'

export default [
  {
    name: 'ConsentManager',
    path: '/consent-manager',
    component: ConsentManager,
    meta: { auth: ['SubscriptionPreference::Read'] },
    children: [
      {
        name: 'ConsentManagerChannels',
        path: 'channels',
        component: ConsentManagerChannelsPage,
        meta: {
          auth: ['SubscriptionPreference::Read'],
          features: ['subscriptionPreferences']
        }
      },
      {
        name: 'ConsentManagerSubscriptionPreferences',
        path: 'subscription',
        component: ConsentManagerSubscriptionPreferencesPage,
        meta: {
          auth: ['SubscriptionPreference::Read'],
          features: ['subscriptionPreferences']
        }
      },
      {
        name: 'ConsentManagerAuditLog',
        path: 'audit-log',
        component: ConsentAuditLog,
        meta: {
          auth: ['SubscriptionPreference::Read'],
          features: ['subscriptionPreferences']
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/modules/consent-manager/router/index.js